export const SAVE_LOCATIONS = "SAVE_LOCATIONS";
export const SAVE_LOCATIONS_SUCCESS = "SAVE_LOCATIONS_SUCCESS";
export const SAVE_LOCATIONS_FAILURE = "SAVE_LOCATIONS_FAILURE";
export const CLEAR_ERROR_SAVING_LOCATIONS = "CLEAR_ERROR_SAVING_LOCATIONS";
export const MOVE_LOCATIONS_SUCCESS = "MOVE_LOCATIONS_SUCCESS";
